import { render, staticRenderFns } from "./MultiSelectCustom.vue?vue&type=template&id=72611e61&"
import script from "./MultiSelectCustom.vue?vue&type=script&lang=js&"
export * from "./MultiSelectCustom.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports